<template>

    <div>
        <div class="container">
            <changes
                v-if="changes"
                :changes="changes"
            ></changes>

            <table class="table table-hover table-striped">
                <thead>
                    <tr>
                        <th class="product-name" colspan="2" v-html="lang('cart.product')"></th>
                        <th v-if="isAuthenticated" class="product-price text-right" v-html="lang('cart.unitprice')"></th>
                        <th class="product-quantity" v-html="lang('cart.count')"></th>
                        <th v-if="isAuthenticated" class="product-subtotal text-right" v-html="lang('cart.total')"></th>
                        <th class="product-remove">&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="products.length === 0">
                        <td colspan="6" v-html="lang('cart.no-products')"></td>
                    </tr>
                    <tr
                        v-for="product in products"
                    >
                        <td>
                            <inertia-link
                                :href="route('products.item', {brand_slug:product.product.brand_slug, slug:product.product.slug})"
                            >
                                <img
                                    :src="product.product.image.url"
                                    :alt="product.product.image.name"
                                    class="thumbnail"
                                />
                            </inertia-link>
                        </td>
                        <td>
                            <h4>
                                <inertia-link
                                    :href="route('products.item', {brand_slug:product.product.brand_slug, slug:product.product.slug})"
                                >
                                    {{ product.product.name }}
                                </inertia-link>
                            </h4>
                            <p>
                                <strong v-html="lang(eanSkuLangKey(product)) + ':'"></strong> {{ product.product.code }}
                            </p>
                        </td>

                        <td
                            v-if="isAuthenticated"
                            class="text-right"
                        >
                            {{ product.product.price | toCurrency }}
                        </td>

                        <td>
                            <div class="input-group ss-deincrease-function nm">
                                <div class="input-group-prepend">
                                    <button
                                        class="btn btn-outline-secondary"
                                        type="button"
                                        @click="decreaseQuantity(product)"
                                    >-</button>
                                </div>
                                <input
                                    type="number"
                                    class="input-text qty text"
                                    step="1"
                                    :title="lang('cart.count')"
                                    size="4"
                                    v-model="product.quantity"
                                    @keydown.enter="onUpdateCart"
                                />
                                <div class="input-group-append">
                                    <button
                                        class="btn btn-outline-secondary"
                                        type="button"
                                        @click="increaseQuantity(product)"
                                    >+</button>
                                </div>
                            </div>
                        </td>

                        <td
                            v-if="isAuthenticated"
                            class="text-right"
                        >
                            {{ totalProductPrice(product) | toCurrency }}
                        </td>

                        <td class="text-right">
                            <button
                                class="btn btn-secondary"
                                type="button"
                                @click="removeProductFromCart(product)"
                                v-tooltip="lang('cart.remove-product')"
                            >
                                <i class="mdi mdi-delete"></i>
                                <span class="sr-only" v-html="lang('cart.remove-product')"></span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="text-right"
                v-if="products.length > 0"
            >
                <button
                    type="button"
                    class="btn btn-primary"
                    @click="onUpdateCart"
                    v-html="lang('cart.update-cart')"
                ></button>
            </div>

            <div class="row">
                <div
                    v-if="isAuthenticated"
                    class="col-6 offset-6"
                >
                    <div
                        v-if="products.length > 0"
                    >
                        <table class="col-8 offset-4 table table-hover">
                            <tbody>
                                <tr class="cart-subtotal">
                                    <th v-html="lang('cart.subtotal')"></th>
                                    <td class="text-right">
                                        {{ subTotal | toCurrency }}
                                    </td>
                                </tr>
                                <tr
                                    v-for="(taxtotal, taxrate) in taxes"
                                >
                                    <th>{{ lang('all.key2', {'%lang%': lang('cart.tax'), '%taxrate%': taxrate}) }}</th>
                                    <td class="text-right">
                                        {{ lang('all.key', {'%toCurrency%': toCurrency(taxtotal) }) }}
                                    </td>
                                </tr>
                                <tr class="order-total">
                                    <th v-html="lang('cart.total')"></th>
                                    <td class="text-right">
                                        {{ lang('all.key', {'%toCurrency%': toCurrency(total) }) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div class="text-right">
                            <inertia-link
                                :href="route('auth.checkout.index')"
                                class="btn btn-primary"
                                v-html="lang('cart.to-checkout')"
                            ></inertia-link>
                        </div>
                    </div>
                </div>

                <div
                    v-else
                    class="col-6 offset-6"
                >
                    <div class="text-right">
                        <inertia-link
                            :href="route('auth.checkout.index')"
                            class="btn btn-primary"
                            v-html="lang('cart.login')"
                        ></inertia-link>
                    </div>
                </div>

            </div>

        </div>

        <div class="modal fade" id="deleteProductFromCartModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">{{ lang('all.product_uit_winkelwagen_verwijderen') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" :aria-label="lang('all.close')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="productToDelete">
                        <p v-html="lang('cart.delete-model.message', {productname: productToDelete.product.name})"></p>
<!--                        <p>Weet je zeker dat product <strong>{{ productToDelete.product.name }}</strong> wilt verwijderen uit je winkelwagen?</p>-->
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary"
                            @click="closeModal"
                            v-html="lang('global.no')"
                        ></button>
                        <button type="button" class="btn btn-primary"
                            @click="removeProductCb()"
                            v-html="lang('global.yes')"
                        ></button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import Layout from "../../../Shared/Layout";
import BaseCart from "../../../components/Cart/BaseCart";
import Changes from '../../../components/Cart/Changes';
import toCurrencyFunc from "../../../filters/toCurrency";
import {mapActions} from "vuex";

export default {

    components: {
        Changes,
    },

    computed: {
        updatePostdata() {
            let products = [];

            this.products.forEach(product => products.push({
                uuid:product.product.uuid,
                quantity:product.quantity,
            }));

            return {products:products};
        },
    },

    data() {
        return {
            productToDelete:null,
        }
    },

    extends:BaseCart,

    layout:Layout,

    metaInfo() {
        return {
            title: this.lang('cart.meta.title'),
            meta: [
                {vmid:'keywords',name:'keywords',content:this.lang('cart.meta.keywords')},
                {vmid:'description',name:'description',content:this.lang('cart.meta.description')},
            ],
        }
    },

    methods: {
        ...mapActions([
            'fetchCart',
        ]),

        eanSkuLangKey(product) {
            return product.product.brand_slug === 'stanleystella' ?
                'products.show.sku' :
                'products.show.ean';
        },

        closeModal() {
            this.productToDelete = null;
            $('#deleteProductFromCartModal').modal('hide');
        },

        onUpdateCart() {
            this.$inertia.patch(this.route('cart.update'), this.updatePostdata, {
                onFinish: () => this.fetchCart()
            });
        },

        removeProductFromCart(product) {
            this.productToDelete = product;

            $('#deleteProductFromCartModal').modal('show');
        },

        removeProductCb() {
            this.removeProduct(this.productToDelete);
            this.closeModal();
        },

        toCurrency(cur) {
            return toCurrencyFunc(cur);
        },

    },

    mounted() {
        this.$GA4.dispatch('view_cart');
    },

    name:'OpenCartIndex',

    props: {
        changes:{
            type:Object,
            default:() => {},
        },
    },

}

</script>
